import ProductionImpactPerSource from "@/components/drawers/ProductDrawer/ProductionImpactPerSource";
import ProductionImpactPerType from "@/components/drawers/ProductDrawer/ProductionImpactPerType";
import NoImpactBanner from "@/components/NoImpactBanner/NoImpactBanner";
import { useDashboardYear } from "@/pages/dashboard/hooks/useDateRange";
import { useDashboardOrderCounts } from "@/pages/dashboard/hooks/usePoSo";
import {
  ProductBy,
  useProductProductionImpactPerSource,
} from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";

function ProductionImpactPerProduct({
  metric: type,
  productId,
  by,
}: {
  metric: ImpactMetric;
  productId: number;
  by: ProductBy;
}) {
  const { data } = useProductProductionImpactPerSource({ productId, by, metric: type.key });
  const { year } = useDashboardYear();

  const { data: orderCounts } = useDashboardOrderCounts({ productId });

  if (orderCounts?.po === 0) {
    return (
      <NoImpactBanner title={`No production impact for this product in ${year}`}>
        <span>
          This product was not found in any <strong>purchase orders</strong> in {year}, so no impact
          could be calculated. Navigate to a different year, or upload{" "}
          <Link to="/orders/purchase_orders">purchase orders</Link>.
        </span>
      </NoImpactBanner>
    );
  }

  if (data?.length === 0) {
    return (
      <NoImpactBanner
        title={`No production impact for ${year}`}
        size="small"
      >
        <span>
          Check if you've uploaded utility data for the <Link to={`/facilities`}>facilities</Link>{" "}
          in which this product was processed in {year}.
        </span>
      </NoImpactBanner>
    );
  }

  return (
    <Row gutter={[10, 10]}>
      <Col span={12}>
        <ProductionImpactPerSource
          metric={type}
          productId={productId}
          by={by}
        />
      </Col>
      <Col span={12}>
        <ProductionImpactPerType
          metric={type}
          productId={productId}
          by={by}
        />
      </Col>
    </Row>
  );
}

export default ProductionImpactPerProduct;
